import { HTMLAttributes, useRef } from 'react';
import { cx } from '@emotion/css';
import { InquiredProductPanel } from './components/InquiredProductPanel';
import { SideMain } from './components/SideMain';
import { LightChatSideContext } from './contexts/LightChatSide';

interface LightChatSideProps extends HTMLAttributes<HTMLElement> {
  conversation: Conversation.Conversation;
}

export const LightChatSide = (props: LightChatSideProps) => {
  const { className, conversation } = props;
  const { buyerId, storeId } = conversation;
  const asideRef = useRef<HTMLDivElement>(null);

  return (
    <LightChatSideContext.Provider value={{ containerRef: asideRef }}>
      <aside ref={asideRef} className={cx(className, 'relative overflow-hidden flex flex-col')}>
        <InquiredProductPanel buyerId={buyerId} storeId={storeId} />
        <SideMain conversation={conversation} />
      </aside>
    </LightChatSideContext.Provider>
  );
};
